import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { EdlComment } from '../model/comment.model';
import { EdlHtmlContent } from '../model/content.model';

@Injectable()
export class ContentApi extends BaseApi {

  constructor(
    @Inject(BASE_URL) private baseUri: string,
    private http: HttpClient
  ) {
    super();
  }


  getLandingPageContent() {
    return this.http.get<EdlHtmlContent[]>(this.baseUri + '/content/landing', {});
  }

  saveContent(content: EdlHtmlContent) {
    return this.http.post<EdlHtmlContent[]>(this.baseUri + '/content/save', content );
  }

}
